/**
 * Consumer launch offer. Matches backend/payments/plans.py monthly
 * and backend/payments/offer.py. One charge, 30 days, no renewal.
 */
export const LAUNCH_OFFER = {
  planId: 'monthly',
  name: '30-day access',
  amount: 19.99,
  currency: 'USD',
  durationDays: 30,
  dailyReplies: 40,
  priceLabel: '$19.99',
  termLabel: 'for 30 days',
  billingLabel: 'One-time payment. No automatic renewal.',
  usageLabel: 'Up to 40 companion replies a day while access is active.',
  supportEmail: 'care@getbyonco.com',
  included: [
    'Plain-language explanations of uploaded report wording',
    'Saved conversations that keep report context',
    'Symptom check-ins and a brief you can take to an appointment',
  ],
  limits: [
    'ByOnco uses AI. It does not diagnose, prescribe, or replace a clinician.',
    'Check-ins are not monitored by a clinician.',
    'Up to 40 companion replies a day.',
    'Access ends after 30 days unless you buy again.',
  ],
};

export const LAUNCH_EVENTS = [
  'landing_view',
  'sample_viewed',
  'checkout_started',
  'payment_completed',
  'access_opened',
];
